import { Route } from '@angular/router';
import { PrincipalComponent, SignInComponent } from '@formulando-frontend/shared';
import { canActivate, redirectLoggedInTo, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['sign-in']);
const redirectLoggedInToApp = () => redirectLoggedInTo(['']);

export const appRoutes: Route[] = [
  { path: 'sign-in', component: SignInComponent, ...canActivate(redirectLoggedInToApp) },
  {
    path: '',
    component: PrincipalComponent,
    children: [
      { path: 'assistente', loadChildren: () => import('./components/assistente/assistente.component').then((c) => c.AssistenteComponent) },
      { path: 'ativo', loadChildren: () => import('./components/ativo/ativo.component').then((c) => c.AtivoComponent) },
      { path: 'formula', loadChildren: () => import('./components/formula/formula.component').then((c) => c.FormulaComponent) },
      { path: 'protocolo', loadChildren: () => import('./components/protocolo/protocolo.component').then((c) => c.ProtocoloComponent) },
      { path: 'solucao', loadChildren: () => import('./components/solucao/solucao.component').then((c) => c.SolucaoComponent) },
    ],
    ...canActivate(redirectUnauthorizedToLogin),
  },
  { path: '**', redirectTo: '' },
];
